import React from 'react';
import MuiAlert from '@material-ui/lab/Alert';

function Toast(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default Toast;